import { FinancialsRowValue } from './types'

export function getYoYData<T extends FinancialsRowValue>(data: T[]) {
  const sortedData = [...data].sort((a, b) => Number.parseInt(a.year) - Number.parseInt(b.year))
  return sortedData.reduce<{
    change: Record<string, number | null>
    changePct: Record<string, number | null>
  }>(
    (acc, { year, value }, i) => {
      const prev = sortedData[i - 1]?.value ?? null
      let change: number | null = null
      let changePct: number | null = null

      if (value !== null && prev !== null && value !== 0 && prev !== 0) {
        change = value - prev
        changePct = ((value - prev) / Math.abs(prev)) * 100
      }

      return {
        change: {
          ...acc.change,
          [year]: change,
        },
        changePct: {
          ...acc.changePct,
          [year]: changePct,
        },
      }
    },
    { change: {}, changePct: {} }
  )
}

export function getMoMPercentageData<T extends FinancialsRowValue>(data: T[]) {
  const sortedData = [...data].sort((a, b) => Number.parseInt(a.year) - Number.parseInt(b.year))
  return sortedData.reduce<Record<string, number | null>>((acc, { year, value }, i) => {
    const prev = sortedData[i - 1]?.value ?? null
    let changePct: number | null = null

    if (value !== null && prev !== null && value !== 0 && prev !== 0) {
      changePct = ((value - prev) / Math.abs(prev)) * 100
    }

    return {
      ...acc,
      [year]: changePct,
    }
  }, {})
}

export function getIsCompact(numOfCols: number, barWidth: number) {
  // ~1400 is max container width
  const maxContainerWidth = Math.min(window.innerWidth, 1400)

  const barsWindowWidthRatio = (barWidth * numOfCols) / maxContainerWidth
  return barsWindowWidthRatio > 0.65
}

export function getHeatmapClassNames(value: number | null = null) {
  if (value === null || value === 0) return 'bg-neutral text-neutral'

  // Negative
  if (value < -80) return 'bg-danger-5 text-danger-5'
  if (value < -60) return 'bg-danger-4 text-danger-4'
  if (value < -40) return 'bg-danger-3 text-danger-3'
  if (value < -20) return 'bg-danger-2 text-danger-2'
  if (value < 0) return 'bg-danger-1 text-danger-1'

  // Positive
  if (value > 80) return 'bg-success-5 text-success-5'
  if (value > 60) return 'bg-success-4 text-success-4'
  if (value > 40) return 'bg-success-3 text-success-3'
  if (value > 20) return 'bg-success-2 text-success-2'
  if (value > 0) return 'bg-success-1 text-success-1'
}
